import { Injectable, inject } from '@angular/core';
import { SiaHttpService } from '../services/http.service';

@Injectable({
  providedIn: 'root',
})
export class SiaIconBadgeApi {
  private http = inject(SiaHttpService);

  private readonly apiController: string = 'badge-icon';

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  getBadgeValue(): Promise<number> {
    return Promise.resolve(2);
    // return this.http.get(`${this.apiController}/`, {});
  }
}
